import { SwitchSpaceModalComponent } from '../../../../deliveries/details/actions/switch-space/switch-space-action.component';
import { SwitchSpaceOrderActionProps, useSwitchSpaceOrderAction } from './switch-space-order.action.hook';

export function SwitchSpaceOrderActionModal(props: SwitchSpaceOrderActionProps) {
  const action = useSwitchSpaceOrderAction(props);

  return <SwitchSpaceModalComponent {...action} />;
}
